<template>
  <div v-if="stageContenttData.pdData.showBlock" class="flex flex-wrap -mb-4" :style="guideStep >= 45 && guideStep <= 49 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['PositionAndDevice']['title']}}</span>
        <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Relationship']['title_info']}`"></i>
        <button
          v-if="!editPageType"
          id="relationship"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Relationship']['video_teaching']}}
        </button>
        <div v-show="stageIndex != 0" class="float-right">
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="stageContenttData.pdData.ditto_identity" class="-my-1" :disabled="editPageType" />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8">
        <div>
          <div class="flex">
            <div class="text-grap-700 align-middle" :class="{ 'ring-4 border-blue-400': guideStep === 48 }">
              <InputSwitch :disabled="editPageType" v-model="stageContenttData.pdData.auto_publisher" @click="selectAll()" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['PositionAndDevice']['position_item_title']}}</span>
            </div>
          </div>
          <div class="flex">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_label']}}</span>
            </div>
          </div>
          <MultiSelect ref="step46Click" v-model="stageContenttData.pdData.device_platforms" :options="devicePlatformsList" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['device_placeholder']" :filter="false" class="w-full rounded-md multiselect-custom" :disabled="editPageType">
            <template #value="slotProps">
              <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                <div>{{selectDeviceLabel[option]}}</div>
              </div>
            </template>
          </MultiSelect>
        </div>
        <div>
          <div class="space-y-2 pt-4" :class="{ 'ring-4 border-blue-400': guideStep === 49 }">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_block_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'關係鏈與受眾'"></i> -->
            </div>
            <Dropdown
              :disabled="editPageType" v-model="stageContenttData.pdData.user_os" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.user_os_list" :placeholder="lang['components']['Event']['PositionAndDevice']['device_block_title_placeholder']" class="w-full rounded-md"
            />
          </div>
        </div>
      </div>
      <div class="flex-1 space-y-4" style="margin-top: 0px;">
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 46 }">
          <div class="flex pt-8">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['position_block_title']}}</span>
            </div>
          </div>
          <MultiSelect ref="step47Click" id="teachingPAD" v-model="publisherPlatFormsDb" :options="stageContenttData.pdData.publisher_platforms_list" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']" :filter="false" class="w-full rounded-md multiselect-custom" :disabled="editPageType" :class="{ 'ring-4 border-blue-400': guideStep === 47 }">
            <template #value="slotProps">
                <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                  <div>{{platFormLabel[option]}}</div>
                </div>
                <template v-if="!slotProps.value || slotProps.value.length === 0">
                    {{lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']}}
                </template>
            </template>
          </MultiSelect>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8" style="margin-top: 0px;">
        <div>
          <div>
            <span class="text-grap-700 align-middle text-sm">Facebook</span>
            <button
              v-if="!editPageType"
              id="identity"
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
              @click="teachVideo()"
            >
              {{lang['components']['Event']['Identity']['video_teaching']}}
            </button>
          </div>
          <input type="hidden" name="step_3_facebook" v-model="stageContenttData.pdData.page_id">
          <Dropdown :disabled="editPageType" v-model="stageContenttData.pdData.page_id" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.adpages_list" :placeholder="lang['components']['Event']['Identity']['facebook_placeholder']" class="w-full rounded-md" />
        </div>
        <div>
          <div>
            <span class="text-grap-700 align-middle text-sm">IG</span>
          </div>
          <Dropdown :disabled="true" v-model="stageContenttData.pdData.ig_username" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.ig_list" placeholder="" class="w-full rounded-md" />
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import InputSwitch from 'primevue/inputswitch';
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'PositionAndDevice',
    components: {
      MultiSelect,
      Dropdown,
      InputSwitch
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      stageContent:{
        type: Object
      },
      stageContentAll:{
        type: Object
      },
      stageIndex: {
        type: Number
      },
      showIdentity: {
        type: Boolean
      },
      viewIdentityDatalist: {
        type: Object
      },
      autoPublisher: {
        type: Boolean
      },
      publisherPlatforms: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        autoPublisherForm: false,
        testValue: ["mobile","desktop"],
        devicePlatformsList: [
          {
            name: "行動裝置",
            code: "mobile",
            disabled: false
          },
          {
            name: "桌上型電腦",
            code: "desktop",
            disabled: false
          }
        ],
        selectDeviceLabel: {mobile:"行動裝置", desktop:"桌上型電腦"},
        publisherPlatFormsDb: [],
        platFormLabel: {facebook:"Facebook", instagram:"Instagram", audience_network:"Audience Network", messenger:"Messenger"},
        usAuto: true,
        selectedTags: [3, 7],
        tags: [
          {
            code: 1,
            text: '排除粉絲專頁',
            checked: false
          },
          {
            code: 2,
            text: '排除購買15天',
            checked: false
          },
          {
            code: 3,
            text: '排除購買30天',
            checked: true
          },
          {
            code: 4,
            text: '排除購買60天',
            checked: false
          },
          {
            code: 5,
            text: '排除RT30天',
            checked: true
          },
          {
            code: 6,
            text: '排除RT60天',
            checked: false
          },
          {
            code: 7,
            text: '預設選項',
            checked: false
          },
        ],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        positionDeviceIdentityStatus: false,
        isPdDataUpdating: false
      }
    },
    watch: {
      // 'viewDatalistData.publisher_platforms'(value){
      //   console.log('viewDatalistData.publisher_platforms');
      //   console.log(value);
      //   let platformsLength = value.length;
      //   console.log(platformsLength);
      //   console.log(this.viewDatalistData.publisher_platforms);
      //   this.publisherPlatFormsDb = value
      //   if(platformsLength == 4){
      //     this.autoPublisherForm = true;
      //     this.autoPublisherData = true;
      //   } else {
      //     this.autoPublisherForm = false;
      //     this.autoPublisherData = false;
      //   }
      // },
      // 'autoPublisherData'(value){
      //   console.log('autoPublisherData');
      //   console.log(value);
      //   console.log(typeof value);
      //   if(value){
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
      //     this.publisherPlatFormsDb = ["facebook","instagram","audience_network","messenger"];
      //   } else {
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = [];
      //     this.publisherPlatFormsDb = [];
      //   }
      // },
      'lang':function(v){
        this.devicePlatformsList = [
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_mobile'],
            code: "mobile",
            disabled: false
          },
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_desktop'],
            code: "desktop",
            disabled: false
          }
        ];
        this.selectDeviceLabel = {mobile:this.lang['components']['Event']['PositionAndDevice']['device_mobile'], desktop:this.lang['components']['Event']['PositionAndDevice']['device_desktop']};
      },
      'stageContenttData.pdData.device_platforms':function(v){
        console.log('stageContenttData.pdData.device_platforms');
        console.log(v);

        if(v != null){
          let devicePlatformsLength = v.length;

          if(v[0] == "desktop" && devicePlatformsLength == 1){
            this.stageContenttData.pdData.publisher_platforms_list = [
              {name: "Facebook", code: "facebook", disabled: true},
              {name: "Instagram", code: "instagram", disabled: true},
              {name: "Audience Network", code: "audience_network", disabled: true},
              {name: "Messenger", code: "messenger", disabled: true},
            ];
            this.publisherPlatFormsDb = ["facebook"];
          } else {
            this.stageContenttData.pdData.publisher_platforms_list = [
              {name: "Facebook", code: "facebook", disabled: false},
              {name: "Instagram", code: "instagram", disabled: false},
              {name: "Audience Network", code: "audience_network", disabled: false},
              {name: "Messenger", code: "messenger", disabled: false},
            ];
          }

          if(devicePlatformsLength == 2){
            this.autoPublisherForm = true
          } else {
            this.autoPublisherForm = false
          }
        }
      },
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'pad'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      guideStep(val) {
        // this.$refs.step47Click.show();
        // this.$refs.step47Click.overlayVisible = value === 47 ? true : false;
        if (val == 47) {
          // console.log(value);
          // this.$refs.step47Click.overlayVisible = true;
          // console.log(this.$refs.step47Click);
          // console.log(this.$refs.step47Click.overlayVisible);

          // this.$refs.step47Click.show();
          // document.getElementById("test").click();

          setTimeout(function(){
              // console.log("I am the third log after 1 seconds");
              document.getElementById("teachingPAD").click();
          },350);
        }

        if (val === 49) {
          this.stageContenttData.pdData.page_id = this.stageContenttData.pdData.adpages_list[0].code;
        }
      },
      'publisherPlatformsData'(value){
        console.log('publisherPlatformsData');
        console.log(value);

        this.publisherPlatFormsDb = value;

        console.log('this.publisherPlatFormsDb');
        console.log(this.publisherPlatFormsDb);
      },
      // 'autoPublisherForm'(value){
      //   console.log('autoPublisherForm');
      //   console.log(value);

      //   this.viewDatalistData.auto_publisher = value;
      // },
      'publisherPlatFormsDb'(value){
        console.log('publisherPlatFormsDb');
        console.log(value);
        // let platformsLength = value.length;

        // console.log('platformsLength');
        // console.log(platformsLength);

        this.stageContenttData.pdData.publisher_platforms = value;
        // this.publisherPlatFormsDb = value;

        // if(platformsLength == 4){
        //   this.autoPublisherForm = true
        // } else {
        //   this.autoPublisherForm = false
        // }

        console.log('this.stageContenttData.pdData.publisher_platforms');
        console.log(this.stageContenttData.pdData.publisher_platforms);
      },
      'stageContenttData.pdData.page_id': function(v){
        console.log('watch stageContenttData.pdData.page_id');
        console.log(v);

        this.$emit('childPageId', v);

        if(v != '' && v != null){
          this.showIdentityMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/campaign_page_instagram.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: v,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                console.log('response:'+response.data.return_data);
                // console.log('b this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
                this.stageContenttData.pdData.ig_username = response.data.return_data;
                this.stageContenttData.pdData.ig_id = response.data.ig_id;
                this.stageContenttData.pdData.ig_list = response.data.data_list;
                // console.log('a this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
              }

              this.showIdentityMyside = true;
            });
        }
      },
      'stageContenttData.pdData.ditto_identity'(value){
        console.log('stageContenttData.pdData.ditto_identity');
        console.log(value);
        console.log('b this.stageContentAllData');
        console.log(this.stageContentAllData);
        console.log(this.stageContenttData);
        console.log(this.stageIndex);

        if(this.stageIndex > 0){
          if(value == true){
            let _beforIndex = this.stageIndex - parseInt(1);

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData));

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ditto_identity = value;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.auto_publisher = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.auto_publisher;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.publisher_platforms));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.publisher_platforms_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.publisher_platforms_list));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.device_platforms));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.user_os = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.user_os;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.user_os_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.user_os_list));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.page_id = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.page_id;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_id = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.ig_id;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_username = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.ig_username;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.adpages_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.adpages_list));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.ig_list));

            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ditto_identity = value;

            console.log('for this.stageContentAllData.subCampaignsContent[this.stageIndex]');
            console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);

            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('this.stageIndex');
            console.log(this.stageIndex);
            for(let i = this.stageIndex; i < subLength; i++){
              console.log(this.stageContentAllData.subCampaignsContent[i].pdData);
              if(this.stageContentAllData.subCampaignsContent[i].pdData.ditto_identity == true){
                this.stageContentAllData.subCampaignsContent[i].pdData.auto_publisher = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.auto_publisher;
                this.stageContentAllData.subCampaignsContent[i].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.publisher_platforms));
                this.stageContentAllData.subCampaignsContent[i].pdData.publisher_platforms_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.publisher_platforms_list));
                this.stageContentAllData.subCampaignsContent[i].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.device_platforms));
                this.stageContentAllData.subCampaignsContent[i].pdData.user_os = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.user_os;
                this.stageContentAllData.subCampaignsContent[i].pdData.user_os_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.user_os_list));
                this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.page_id = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.page_id;
                this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_id = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.ig_id;
                this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_username = this.stageContentAllData.subCampaignsContent[_beforIndex].pdData.ig_username;
                this.stageContentAllData.subCampaignsContent[i].pdData.adpages_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.adpages_list));
                this.stageContentAllData.subCampaignsContent[i].pdData.ig_list = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_list));
              } else {
                break;
              }
            }
          }
        }

        console.log('a this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      'stageContenttData.pdData': {
        handler(newValue, oldValue) {
          console.log('pdData changed:', newValue);
          console.log('pdData olddata:', oldValue);

          if(this.isPdDataUpdating == true){
            return;
          }

          this.isPdDataUpdating = true;

          this.pdDataUdate(newValue);

          setTimeout(() => {
            this.isPdDataUpdating = false;
          }, 0);
        },
        deep: true // 深度监控
      },
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingMethod');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_pad')

        this.vars.start = 0
        this.vars.end = 16
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      testPAD() {
        console.log('hello')
        this.$refs.step47Click.show();
        this.$refs.step47Click.overlayVisible = true;
        console.log(this.$refs.step47Click);
      },
      selectAll (event) {
        // console.log(this.autoPublisherData)
        if(this.editPageType == false){
          if(!this.autoPublisherForm){
            this.autoPublisherForm = true;
            this.autoPublisherData = true;
            // this.stageContenttData.pdData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
            // this.publisherPlatFormsDb = ["facebook","instagram","audience_network","messenger"];
            this.stageContenttData.pdData.device_platforms = ["mobile","desktop"];
          } else {
            this.autoPublisherForm = false;
            this.autoPublisherData = false;
            this.stageContenttData.pdData.publisher_platforms = ["facebook"];
            this.publisherPlatFormsDb = ["facebook"];
            this.stageContenttData.pdData.device_platforms = ["desktop"];
          }
        }

        // if (!this.isSelect) {
        //   console.log('is checked');
        //   this.list.map(function(value, key) {
        //     console.log('value:'+value.name)
        //     if(value.status == 1){
        //       value.status = 2;
        //     }
        //   });
        // } else {
        //   console.log('un checked');
        // }
      },
      pdDataUdate(newValue){
        console.log(this.stageIndex);

        console.log('pdDataUdate stageContenttData.pdData');
        console.log(this.stageContentAllData);
        if(this.stageIndex > 0){
          let _beforeIndex = this.stageIndex - parseInt(1);

          console.log(this.stageContentAllData.subCampaignsContent);
          console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
          console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData);
          let _newDataAutoPublisher = newValue.auto_publisher;
          let _newDataPublisherPlatforms = JSON.stringify(newValue.publisher_platforms);
          let _newDataDevicePlatforms = JSON.stringify(newValue.device_platforms);
          let _newDataUserOs = newValue.user_os;
          let _newDataPageId = newValue.page_id;
          let _newDataIgId = newValue.ig_id;
          let _newDataIgUsername = newValue.ig_username;
          let _oldDataAutoPublisher = this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.auto_publisher;
          let _oldDataPublisherPlatforms = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.publisher_platforms);
          let _oldDataDevicePlatforms = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.device_platforms);
          let _oldDataUserOs = this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.user_os;
          let _oldDataPageId = this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.page_id;
          let _oldDataIgId = this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.ig_id;
          let _oldDataIgUsername = this.stageContentAllData.subCampaignsContent[_beforeIndex].pdData.ig_username;

          // console.log(_newDataAutoPublisher);
          // console.log(_oldDataAutoPublisher);
          // console.log(_newDataLocales);
          // console.log(_oldDataLocales);
          // console.log(_newDataLocationRange);
          // console.log(_oldDataLocationRange);
          // console.log(_newDataLocations);
          // console.log(_oldDataLocations);
          // console.log(newValue.ditto_identity);

          if((_newDataAutoPublisher == _oldDataAutoPublisher) && (_newDataPublisherPlatforms == _oldDataPublisherPlatforms) && (_newDataDevicePlatforms == _oldDataDevicePlatforms) && (_newDataUserOs == _oldDataUserOs) && (_newDataPageId == _oldDataPageId) && (_newDataIgId == _oldDataIgId) && (_newDataIgUsername == _oldDataIgUsername) && newValue.ditto_identity == true){
            console.log('#一樣');
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ditto_identity = true;
          } else {
            console.log('#不一樣');
            this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ditto_identity = false;
          }
        } else {
          let subLength =  this.stageContentAllData.subCampaignsContent.length;
          console.log('0');
          console.log(this.stageIndex);
          for(let i = 1; i < subLength; i++){
            console.log('this.stageContentAllData.subCampaignsContent['+i+'].pdData');
            console.log(this.stageContentAllData.subCampaignsContent[i].pdData);
            if(this.stageContentAllData.subCampaignsContent[i].pdData.ditto_identity == true || this.stageContentAllData.haveTest == true){
              this.stageContentAllData.subCampaignsContent[i].pdData.auto_publisher = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.auto_publisher;
              this.stageContentAllData.subCampaignsContent[i].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.publisher_platforms));
              this.stageContentAllData.subCampaignsContent[i].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.device_platforms));
              this.stageContentAllData.subCampaignsContent[i].pdData.user_os = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.user_os;
              this.stageContentAllData.subCampaignsContent[i].pdData.page_id = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.page_id;
              this.stageContentAllData.subCampaignsContent[i].pdData.location_types = this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.location_types;
              this.stageContentAllData.subCampaignsContent[i].pdData.ig_id = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_id));
              this.stageContentAllData.subCampaignsContent[i].pdData.ig_username = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].pdData.ig_username));
            } else {
              break;
            }
          }
        }

        console.log('pdDataUdate b this.stageContentAllData');
        console.log(this.stageContentAllData);
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      stageContenttData:{
        get: function () {
          return this.stageContent
        },
        set: function (value) {
          this.$emit('update:stageContenttData', value)
        },
      },
      stageContentAllData:{
        get: function () {
          return this.stageContentAll
        },
        set: function (value) {
          this.$emit('update:stageContentAllData', value)
        },
      },
      viewIdentityDatalistData: {
        get: function () {
          return this.viewIdentityDatalist
        },
        set: function (value) {
          this.$emit('update:viewIdentityDatalistData', value)
        },
      },
      autoPublisherData: {
        get: function () {
          return this.autoPublisher
        },
        set: function (value) {
          this.$emit('update:autoPublisherData', value)
        },
      },
      publisherPlatformsData: {
        get: function () {
          return this.publisherPlatforms
        },
        set: function (value) {
          this.$emit('update:publisherPlatformsData', value)
        },
      },
    },
  }
</script>
<style lang="scss" scoped>
  /*::v-deep(.multiselect-custom) {
    .p-multiselect-token {
      font-size: .875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.25rem;
      display: inline-flex;
      margin: 0.25rem;
      --tw-bg-opacity: 1;
      background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  }*/

  ::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);

        img.flag {
            width: 17px;
        }
    }
  }
</style>